import { useSearchParams } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@clerk/clerk-react";

const LOCAL_SERVER = import.meta.env.VITE_LOCAL_SERVER;
const PUBLIC_SERVER = import.meta.env.VITE_PUBLIC_SERVER;
const isLocal = import.meta.env.MODE === "development";

export const useTanFetch = <T = unknown>(
  key: (string | URLSearchParams)[],
  ignoreParams?: boolean,
): {
  data: T;
  isLoading: boolean;
  error: Error | null;
  isError: boolean;
  isSuccess: boolean;
} => {
  const { getToken } = useAuth();
  const [searchParams] = useSearchParams();

  if (!key) {
    throw new Error("Invalid path");
  }
  const url = ignoreParams
    ? `${isLocal ? LOCAL_SERVER : PUBLIC_SERVER}/${key[0]}`
    : `${isLocal ? LOCAL_SERVER : PUBLIC_SERVER}/${key[0]}${searchParams.size !== 0 ? "?" : ""}${searchParams.toString()}`;

  const {
    data,
    isPending: isLoading,
    isError,
    isSuccess,
    error,
  } = useQuery({
    queryKey: key,
    retry: 3,
    refetchIntervalInBackground: false,
    queryFn: async () => {
      const token = await getToken();

      if (!token) {
        return "unauthorized";
      }


      const res = await fetch(url, { headers: { Authorization: token } });

      if (!res.ok) {
        return false;
      }

      return res.json();
    },
  });

  return { data, isLoading, error, isError, isSuccess };
};
